import { render, staticRenderFns } from "./KS-SL-Disclosure.vue?vue&type=template&id=0251cdc4&scoped=true&"
import script from "./KS-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./KS-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./KS-SL-Disclosure.vue?vue&type=style&index=0&id=0251cdc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251cdc4",
  null
  
)

export default component.exports